










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class LengthLabel extends Vue {
  @Prop({
    default: 'standard'
  })
  public unit!: string;

  @Prop({
    default: 0
  })
  public cmValue!: number;

  @Prop({
    default: 0
  })
  public inValue!: number;

  @Prop({
    default: false
  })
  public abbreviated!: boolean;

  @Prop({
    default: false
  })
  public double!: boolean;

  get inValueDecimalFormatted() {
    return this.inValue.toFixed(1);
  }
  get cmValueDecimalFormatted() {
    return this.cmValue.toFixed(1);
  }

}
